import React, {useEffect, useState} from 'react';
import {Button, Modal, Card, Table, Tag, Tooltip} from 'antd';
import styles from './sensitive.hit.table.module.less';
import {sensitiveHitDownloadUrl, sensitiveHitList} from '@/api/sensitiveHit';
import '@/util/dayjsInit';
import dayjs from 'dayjs';
import {ExportOutlined} from '@/icons';
import DateRange from '@/page/app/ReportPage/component/DateRange';
import {getStorageCorpId} from '@/util/AuthStore';
import InterceptConPage from '@/page/conversation/InterceptConPage';

function SensitiveHitTable({editable}) {
    const extra = (
        <DateRange onChange={onChange}>
            <Tooltip title="导出 Excel">
                <Button
                    icon={<ExportOutlined />}
                    onClick={sensitiveHitDownload}
                    disabled={!editable}
                />
            </Tooltip>
        </DateRange>
    );

    const [dateRange, setDateRange] = useState([
        dayjs().subtract(7, 'd').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
    ]);
    const columns = [
        {
            title: '关键词',
            dataIndex: 'sensitiveName',
        },
        {
            title: '拦截方式',
            dataIndex: 'interceptType',
            render: interceptType => (
                <>
                    {interceptType === 1 && <Tag color="#f50">警告并拦截发送</Tag>}
                    {interceptType === 2 && <Tag color="#ff8000">仅发警告</Tag>}
                    {interceptType === 3 && <Tag color="#cccc10">仅触发通知</Tag>}
                </>
            ),
        },
        {
            title: '内容',
            dataIndex: 'content',
            render: (text, record) => <a onClick={() => openModal(record)}>{text}</a>,
        },
        {
            title: '触发人',
            dataIndex: 'fromName',
            render: (text, record) => {
                let value = record.fromName + '(' + record.fromId.toUpperCase() + ')';
                return value;
            },
        },
        {
            title: '邮箱',
            dataIndex: 'email',
        },
        {
            title: '接收人',
            dataIndex: 'toName',
        },
        {
            title: '接收群名',
            dataIndex: 'roomName',
        },
        {
            title: '接收人类型',
            dataIndex: 'type',
        },
        {
            title: '发送日期',
            dataIndex: 'sendTime',
            render: text => <>{dayjs(parseInt(text)).format('YYYY-MM-DD HH:mm:ss')}</>,
        },
    ];
    useEffect(() => {
        init();
    }, []);
    const [data, setData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [intercept, setIntercept] = useState(null);

    function init() {
        sensitiveHitList().then(res => {
            setData(res.data.records);
        });
    }

    function sensitiveHitDownload() {
        const url = sensitiveHitDownloadUrl(dateRange[0], dateRange[1], getStorageCorpId());
        console.log(url);
        window.open(url);
    }

    function onChange(dates, dateStrings) {
        console.log(dates, dateStrings);
        setDateRange(dateStrings);
    }

    function openModal(record) {
        setIntercept(record);
        setVisible(true);
    }

    function close() {
        setIntercept(null);
        setVisible(false);
    }

    return (
        <Card title="敏感词命中记录" extra={extra} style={{height: 'calc(100vh - 200px)', overflowY: 'auto'}}>
            <div className={styles.container}>
                <Table columns={columns} dataSource={data} rowKey={record => record.id} scroll={{ y: 'calc(100vh - 300px)' }} />
            </div>
            <Modal title="聊天内容" visible={visible} onCancel={close} width={'60%'} footer={null}>
                {intercept && <InterceptConPage intercept={intercept} />}
            </Modal>
        </Card>
    );
}

export default SensitiveHitTable;
